import { useState } from "react";
import { Modal, Checkbox, Input, Form, Col, Row } from "antd";
import { TOKEN_KEY } from "../../../authProvider";
import { useCustomMutation, useNotification, useUpdate } from "@refinedev/core"; // Import notification utility
import ChannelBanButton from "./ChannelBanButton";
import GlobalBanButton from "./GlobalBanButton";


const BanModal = ({ itemID, is24H, channelBanOnly, userID }: { itemID: string, is24H: boolean, channelBanOnly: boolean, userID: string }) => {
  const { TextArea } = Input;
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [form] = Form.useForm();
  const { open: notify } = useNotification();
  
  const { mutate, isLoading } = useCustomMutation({
    mutationOptions: {
      onMutate: () => {
        
      }
    }
  });
  

  const handleCancel = () => {
      setIsModalOpen(false);
      form.resetFields(); 
  };


  const handleSubmit = async () => {
    try {
      const token = localStorage.getItem(TOKEN_KEY);
      const apiUrl = import.meta.env.VITE_API_URL;
      const values = await form.validateFields();

      mutate(
        {
          url: `${apiUrl}/admin/report/submit_action`,
          method: 'post',
          config: {
            headers: {
              'Authorization': `Bearer ${token}`
            },
          },
          values: {
            actionType: "ban",
            itemID,
            userID,
            ban: {
              ipBan: values?.ipBan || false,
              reason: values?.reason,
              shadow: values?.shadow || false,
              channelBanOnly,
              ...(is24H ? { timeout: 1440 } : {})
            }
          },
        },
        {
          onSuccess: (data: any) => {
            notify!({
              type: "success",
              message: "Ban submitted successfully",
              description: data?.message ,
            });
          },
          onError: (error: any) => {
            notify!({
              type: "error",
              message: "Failed to submit ban",
              description: error?.message,
            });
          }
        }
      );
      
      setIsModalOpen(false);
      form.resetFields();
    } catch (error) {
      console.log("Error banning user:", error)
    }
  };

    return (
      <>
        {channelBanOnly ? (
            <ChannelBanButton handleClick={() => setIsModalOpen(true)} is24H={is24H} isLoading={isLoading} />
          ) : (
            <GlobalBanButton handleClick={() => setIsModalOpen(true)} is24H={is24H} isLoading={isLoading} />
        )}
            
        <Modal
          title="Ban Reason"
          open={isModalOpen}
          onCancel={handleCancel}
          onOk={handleSubmit}
          okText="Submit"
        >
          <Form layout="vertical" form={form}>
            <Form.Item name="reason">
              <TextArea placeholder="Enter a reason" />
            </Form.Item>
            <Row gutter={16} style={{ marginTop: 16 }}>
              <Col>
                <Form.Item name="ipBan" valuePropName="checked">
                  <Checkbox>Ip Ban (Chat only)</Checkbox>
                </Form.Item>
              </Col>
              <Col>
                <Form.Item name="shadow" valuePropName="checked">
                  <Checkbox>Shadow ban</Checkbox>
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </Modal>
      </>
    );
};

export default BanModal;
